/** Shared Ant Design Drawer settings for Welcome / AI report review side panels. */

/** Portal topic-tag dropdowns above the drawer (z-index in consoleLayout.css). */
export const WELCOME_DRAWER_DROPDOWN_OVERLAY_CLASS =
  "welcome-drawer-dropdown-overlay";

export function welcomeReviewsDrawerWidth() {
  if (typeof window === "undefined") return 650;
  if (window.innerWidth > 1300) return 650;
  if (window.innerWidth > 500) return 450;
  return 350;
}

export const WELCOME_REVIEWS_DRAWER_SHARED_PROPS = {
  placement: "right",
  closable: true,
  maskClosable: true,
  destroyOnHidden: true,
  keyboard: true,
  zIndex: 2100,
  rootClassName: "welcome-reviews-drawer",
  getContainer: () =>
    typeof document !== "undefined" ? document.body : undefined,
  styles: {
    header: {
      flexShrink: 0,
    },
    body: {
      overflow: "auto",
      overscrollBehavior: "contain",
    },
  },
};
